import { render, staticRenderFns } from "./RemissionTableComponent.vue?vue&type=template&id=1476d613"
import script from "./RemissionTableComponent.vue?vue&type=script&lang=js"
export * from "./RemissionTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports